import { Heading, Separator } from "@radix-ui/themes";

export default function SidepanelSection({ title, children }) {
  return (
    <div className="sidepanel-section mb-8">
      <div className="sidepanel-section-header">
        <Heading size={"4"}>{title}</Heading>
        <Separator size={"4"} className="my-2" />
      </div>
      <div className="flex flex-col gap-2">{children}</div>
    </div>
  );
}
